import Swiper from "swiper";

export const slider = () => {
  const swiper = new Swiper(".swiper", {
    allowSlidePrev: true,
    allowTouchMove: true,
    centeredSlides: true,
    direction: 'horizontal',
    draggable: true,
    effect: 'slide',
    loop: true,
    navigation: true,
    slidesPerView: 'auto',
    spaceBetween: 20,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },

    breakpoints: {
      768: {
        centeredSlides: false,
      },

      1024: {
        centeredSlides: false,
        loop: false,
      },
    },
  });
};
